import { SaveReportOption, SaveReportValues } from './SaveReportModal.types';

export const SAVE_REPORT_TITLE = 'Save Report';
export const SAVE_REPORT_DESCRIPTION = 'Save this report for future use.';

export const NAME_PLACEHOLDER = 'e.g. Monthly Security Summary';
export const EXPORT_FORMAT_PLACEHOLDER = 'Select label';
export const TENANT_PLACEHOLDER = 'Select a tenant';
export const PROPERTY_PLACEHOLDER = 'Select a property';
export const FREQUENCY_PLACEHOLDER = 'Select label';
export const RECIPIENTS_PLACEHOLDER = 'Insert email';

export const DELIVERY_LABELS = {
	on: 'Enabled',
	off: 'Disabled'
};

export const EXPORT_FORMAT_OPTIONS: SaveReportOption[] = [
	{ value: 'pdf', label: 'PDF' },
	{ value: 'csv', label: 'CSV' },
	{ value: 'xlsx', label: 'Excel' }
];

export const DELIVERY_FREQUENCY_OPTIONS: SaveReportOption[] = [
	{ value: 'daily', label: 'Daily' },
	{ value: 'weekly', label: 'Weekly' },
	{ value: 'monthly', label: 'Monthly' },
	{ value: 'quarterly', label: 'Quarterly' },
	{ value: 'annually', label: 'Annually' }
];

export const EMPTY_SAVE_REPORT_VALUES: SaveReportValues = {
	name: '',
	exportFormat: undefined,
	tenant: undefined,
	property: undefined,
	automaticDelivery: false,
	deliveryFrequency: undefined,
	recipients: []
};
